<template>
  <div class="provider-list">
    <provider-list-item :provider="provider" :key="provider.providerId"
        v-for="provider in providers" />
  </div>
</template>

<style scoped>
  .provider-list {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
</style>

<script>
import ProviderListItem from './ProviderListItem.vue';

export default {
  name: 'provider-list-view',
  props: {
    providers: {
      type: Array,
      required: true,
    },
  },
  components: {
    ProviderListItem,
  },
};
</script>
